import { useEffect, useState } from 'react'
import {
    ScoopSpinner,
    ScoopTable,
    ScoopText,
    ScoopButton,
    ScoopColumn,
    ScoopCenter,
} from '../../../../ui'
import styles from './PreviewTab.module.scss'

export const PreviewTab = ({ value, server, inboxID, singleQuery }) => {
    const [previewData, setPreviewData] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        updatePreviewData()
    }, [value])

    const updatePreviewData = () => {
        if (!server) return
        setLoading(true)
        if (value === 4) {
            server.sheetPostData(
                {
                    action: 'getCFWPreviewData',
                    inboxID: inboxID,
                },
                processPreviewData
            )
        } else {
            server.sheetPostData(
                {
                    action: 'getCSWPreviewData',
                    inboxID: inboxID,
                    singleQuery: singleQuery,
                },
                processPreviewData
            )
        }
    }

    const processPreviewData = (results) => {
        if (results && results.rows) {
            setPreviewData(results)
        } else {
            setPreviewData(null)
        }
        setLoading(false)
    }

    return (
        <ScoopColumn className={styles.mainContainer}>
            {value === 4 && (
                <ScoopButton size="xs" onClick={updatePreviewData}>
                    Update Preview
                </ScoopButton>
            )}
            <ScoopColumn className={styles.contentWrapper}>
                {previewData && !loading && (
                    <div className={styles.dataGridContainer}>
                        <ScoopTable
                            columns={previewData.columns}
                            rows={previewData.rows}
                            rowHeight={20}
                            domLayout="normal"
                            height="100%"
                            emptyMessage="No preview data available"
                        />
                    </div>
                )}
                {loading && (
                    <ScoopCenter className={styles.loadingContainer}>
                        <ScoopSpinner size={72} />
                    </ScoopCenter>
                )}
                {!previewData && !loading && (
                    <ScoopCenter className={styles.emptyStateContainer}>
                        <ScoopText className={styles.emptyStateText}>
                            No preview data available
                        </ScoopText>
                    </ScoopCenter>
                )}
            </ScoopColumn>
        </ScoopColumn>
    )
}
